import Button from '../../common/components/button';
import Div from '../../common/components/div';
import translate from '../../common/functions/translate';

interface LoginButtonSectionProps {
    isLoading: boolean
}

export default function LoginButtonSection(props: LoginButtonSectionProps) {
    return <>
        <Div isRow={true} paddingBottom={3} paddingTop={4}>
            <Div cols={12}>
                <Button
                    disabled={props.isLoading}
                    variation={'solid'}
                    id={'login-button'}
                    size={'big'}
                    type={'submit'}
                    isLoading={props.isLoading}
                    mfaAnalyticsData={{
                        text: translate('log_in_upper'),
                        parentComponentHeading: translate('login')
                    }}
                >
                    {translate('log_in_upper')}
                </Button>
            </Div>
        </Div>
    </>
}
